import { SLICE_TAG } from '@/constants';

import { apiSlice } from '../api-slice';
import { SettingsStoreResponseSchema } from './settings.api-schema';

// import { SupplierResponseSchema } from '';

export const settingsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateStoreSettings: builder.mutation({
      query: (data) => ({
        url: 'settings/store',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: [SLICE_TAG.SETTINGS],
    }),

    getStoreSettings: builder.query({
      query: (queryParams) => ({
        url: 'settings/store',
        params: queryParams,
        method: 'GET',
      }),
      providesTags: [SLICE_TAG.SETTINGS],
      // keepUnusedDataFor: 600,
      transformResponse: (response) => {
        return SettingsStoreResponseSchema.parse(response);
      },
    }),
  }),
});

export const { useGetStoreSettingsQuery, useUpdateStoreSettingsMutation } =
  settingsApi;
